import { SupportedLocale } from '@afterpay/types'

export const billingAddressFFFallback = (locale: SupportedLocale | undefined): boolean => locale !== 'en-AU' && locale !== 'en-NZ'
